// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2hUGB","inputWrap":"CustomTip_inputWrap__148ok"};